import { BlockWrapper, defineBlock, smartProps, useEditor, useInspectorControl } from '@smartfire/js-block-engine';
import { EditableText } from '@smartfire/components';
import React from 'react';
import { GuedelonButton } from '../bouton-guedelon/button';
import style from './block.module.scss';
import { ReactComponent as Icon } from './ic_geo.svg';
import { ReactComponent as SmartfireIcon } from '../assets/smartfire_icone.svg';

const InspectorLazy = React.lazy(() => import('./Inspector'));

type TwoColumnsBlockProps = {
    buttonLinkL: string;
    buttonLinkR: string;
    buttonTextL: string;
    buttonTextR: string;
    iconL: boolean;
    iconR: boolean;
};
function Block({
    buttonLinkL,
    buttonLinkR,
    buttonTextL,
    buttonTextR,
    iconL,
    iconR,
}: TwoColumnsBlockProps): JSX.Element {
    const { isEditing } = useEditor();
    useInspectorControl(InspectorLazy, []);

    return (
        <BlockWrapper.Div className={style.block}>
            <div className={style.content}>
                <div className={style.grid}>
                    <div className={style.col}>
                        <EditableText
                            tagName="h3"
                            placeholder="ajouter un titre"
                            smartProp="titleL"
                            allowedFormats={['core/link']}
                        />
                        <EditableText
                            tagName="p"
                            placeholder="ajouter un texte"
                            smartProp="text1L"
                            allowedFormats={['core/bold', 'core/link']}
                        />
                        <ul>
                            <EditableText
                                tagName="ul"
                                placeholder="ajouter un texte à puces"
                                smartProp="bulletL"
                                allowedFormats={['core/bold', 'core/link']}
                                multiline="li"
                            />
                        </ul>
                        <EditableText
                            tagName="p"
                            placeholder="ajouter un texte"
                            smartProp="text2L"
                            allowedFormats={['core/bold', 'core/link']}
                        />
                        {(isEditing || (buttonLinkL && buttonTextL)) && (
                            <GuedelonButton
                                className={style.guedelonButton}
                                href={isEditing ? undefined : buttonLinkL}
                                external={true}
                            >
                                {iconL && <Icon />}
                                <EditableText tagName="span" placeholder="ajouter un texte" smartProp="buttonTextL" />
                            </GuedelonButton>
                        )}
                    </div>

                    <div className={style.col}>
                        <EditableText
                            tagName="h3"
                            placeholder="ajouter un titre"
                            smartProp="titleR"
                            allowedFormats={['core/link']}
                        />
                        <EditableText
                            tagName="p"
                            placeholder="ajouter un texte"
                            smartProp="text1R"
                            allowedFormats={['core/bold', 'core/link']}
                        />
                        <EditableText
                            tagName="ul"
                            placeholder="ajouter un texte à puces"
                            smartProp="bulletR"
                            allowedFormats={['core/bold', 'core/link']}
                            multiline="li"
                        />

                        <EditableText
                            tagName="p"
                            placeholder="ajouter un texte"
                            smartProp="text2R"
                            allowedFormats={['core/bold', 'core/link']}
                        />
                        {(isEditing || (buttonLinkR && buttonTextR)) && (
                            <GuedelonButton
                                className={style.guedelonButton}
                                href={isEditing ? undefined : buttonLinkR}
                                external={true}
                            >
                                {iconR && (
                                    <div className={style.icon}>
                                        <Icon />
                                    </div>
                                )}
                                <EditableText tagName="span" placeholder="ajouter un texte" smartProp="buttonTextR" />
                            </GuedelonButton>
                        )}
                    </div>
                </div>
            </div>
        </BlockWrapper.Div>
    );
}

export default defineBlock({
    Block: Block as React.FC<unknown>,
    smartProps: {
        titleL: smartProps.string.withDefault(''),
        titleR: smartProps.string.withDefault(''),
        text1L: smartProps.string.withDefault(''),
        text1R: smartProps.string.withDefault(''),
        bulletL: smartProps.string.withDefault(''),
        bulletR: smartProps.string.withDefault(''),
        text2L: smartProps.string.withDefault(''),
        text2R: smartProps.string.withDefault(''),
        buttonTextL: smartProps.string.withDefault(''),
        buttonLinkL: smartProps.string.withDefault(''),
        buttonTextR: smartProps.string.withDefault(''),
        buttonLinkR: smartProps.string.withDefault(''),
        iconL: smartProps.bool.withDefault(false),
        iconR: smartProps.bool.withDefault(false),
    },
    setup: {
        title: '2 colonnes',
        icon: SmartfireIcon,
    },
});
